import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Icon } from 'xm-spark';

import style from './DataLoadError.module.scss';

export default function DataLoadError(props) {
  const { icon, message, className } = props;

  return (
    <div
      className={classnames(style.wrapper, className)}
      data-testid="dataLoadError"
    >
      <div className={style.container}>
        <div className={style.icon}>{icon}</div>
        <div className={style.text}>{message}</div>
      </div>
    </div>
  );
}

DataLoadError.displayName = 'DataLoadError';

DataLoadError.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.node,
  className: PropTypes.string,
};

DataLoadError.defaultProps = {
  icon: <Icon type="icon-warning" />,
  message: <FormattedMessage id="DATA_LOAD_ERROR" />,
  className: '',
};
